export default "__VITE_ASSET__D$nCiqu___"